export enum SCHEDULES_NAMES {
  GlobalSchedule = "Global schedule",
  QuickDownload = "Quick schedule"
}

export enum SCHEDULES_SCOPE {
  GlobalSchedule = 0,
  QuickSchedule = 1,
  Custom = 2
}

export enum SCHEDULE_STATUS {
  NotSelected = "not selected",
  Selected = "selected"
}

export enum MAX_SCHEDULES_COUNT {
  GlobalConfigured = 3,
  NoGlobalConfigured = 2
}

export enum SCHEDULE_PAYLOAD_NAMES {
  Name = "name",
  StartDate = "startDate",
  Repeat = "repeat",
  CustomRepeat = "customRepeat",
  FileTypes = "fileTypes",
  Global = "global",
  MonthlyRepeat = "monthlyRepeat",
  Driver1Slot = "slot1",
  Driver2Slot = "slot2"
}

export enum REPEAT_DAY_VALUES {
  Daily = 1,
  Hourly = -1,
  Weekly = 7,
  Biweekly = 14,
  Every28Days = 28,
  Every90Days = 90
}

export enum REPEAT_TYPE_VALUES {
  Hourly = "hourly",
  Single = "single",
  Multiple = "multiple"
}

export enum REPEAT_NAME_VALUES {
  Custom = "Custom",
  Daily = "Daily",
  Hourly = "Hourly",
  Weekly = "Weekly",
  Biweekly = "Biweekly",
  Every28Days = "Every28Days",
  Every90Days = "Every90Days",
  Monthly = "Monthly"
}

export enum CUSTOM_REPEAT_INPUT_REQUIREMENTS {
  Min = 1,
  Max = 366
}

export enum CUSTOM_DAY_START_OF_PROPERTY_NAMES {
  Day = "day",
  Days = "days"
}
